<style scoped></style>

<template>
  <Form label-position="top" ref="form" :model="formData" :rules="rules">
    <FormItem label="货物" prop="goodsId">
      <GoodsChoose v-model="formData.goodsId" />
    </FormItem>
    <FormItem label="类型" prop="type">
      <RadioGroup v-model="formData.type">
        <Radio :label="1" border>生成</Radio>
        <Radio :label="2" border>消耗</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="数量" prop="volume">
      <InputNumber controls-outside v-model="formData.volume" />
    </FormItem>
    <FormItem label="损耗" prop="lossVolume">
      <InputNumber controls-outside v-model="formData.lossVolume" />
    </FormItem>
    <FormItem label="备注" prop="remark">
      <Input type="textarea" v-model="formData.remark" placeholder="请输入备注" />
    </FormItem>
  </Form>
</template>

<script>
import GoodsChoose from '../../../base/choose.vue'
export function getDefault () {
  return {
    id: null,
    name: null,
    goodsProduceStandardId: null,
    type: 1,
    goodsId: null,
    volume: null,
    lossVolume: null,
    remark: null
  }
}

const rules = Object.freeze({
  goodsId: [
    { required: true, message: '请选择货物' }
  ],
  type: [
    { required: true, message: '请选择类型' }
  ],
  volume: [
    { required: true, message: '请输入数量' }
  ],
  lossVolume: [
    { required: true, message: '请输入损耗' }
  ],
})

export default {
  components: { GoodsChoose },
  props: {
    data: { type: Object, default: null }
  },
  data () {
    return {
      formData: this.data || getDefault(),
      rules
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.formData = this.data ? JSON.parse(JSON.stringify(this.data)) : getDefault()
      }
    }
  },
  methods: {
    getFormData () {
      return new Promise(resolve => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve(JSON.parse(JSON.stringify(this.formData)))
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>
